import React from 'react'
import { Route, Redirect } from 'react-router'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { Routes } from '..'

import PermissionErrorPage from '../../pages/PermissionError'

import { selectAccess } from '@SonarCX/slices/accessSlice'
import useAccess from '@SonarCX/hooks/useAccess'

interface RestrictedRouteProps {
  component: () => JSX.Element
  permissions: string | string[] | boolean
  path: string
}

/// This route checks for credentials and permissions
const RestrictedRoute: React.FC<RestrictedRouteProps> = ({
  component: Component,
  permissions,
  ...otherProps
}) => {
  const { loaded } = useAppSelector(selectAccess)
  const hasCredentials = !!localStorage.getItem('session_token')

  const hasPermission = useAccess()

  const canView = React.useMemo(() => {
    if (typeof permissions === 'boolean') {
      return permissions
    }

    return hasPermission(permissions)
  }, [hasPermission, permissions])

  if (!hasCredentials) {
    return <Redirect to={Routes.LOGIN} />
  }

  if (loaded && !canView) {
    return <PermissionErrorPage />
  }

  return <Route {...otherProps} render={() => <Component />} />
}

export default React.memo(RestrictedRoute)
